<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-account-multiple-check</v-icon>
                <span class="title font-weight-light">Configuração de Frequencias</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-form id="form" ref="form" v-model="valid" lazy-validation>

                    <v-row>
                        <v-col v-if="filtro.modoListagem" cols="12" sm="12" md="6">
                            <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="onSearchProjeto" clearable
                                item-text="codigoNome" item-value="id" label="Projeto" dense outlined/>
                        </v-col>   
                        <v-col v-else cols="12" sm="12" md="6">
                            <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="onSearchProjeto" clearable
                                item-text="codigoNome" item-value="id" label="Projeto" :rules="fieldRules" dense outlined/>
                        </v-col>     
                        <v-col cols="12" sm="12" md="6">
                            <v-autocomplete v-model="filtro.beneficiarioId" :items="beneficiarios" :loading="isBeneficiarioLoading" :search-input.sync="onSearchBeneficiario" clearable
                                item-text="nome" item-value="id" label="Beneficiário" dense outlined/>
                        </v-col>        
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="5">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataInicio" label="Data de Início" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataInicio" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="5">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataTermino" label="Data de Término" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataTermino" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-switch v-model="filtro.modoListagem" :label=" filtro.modoListagem ? 'Modo: Listagem' : 'Modo: Gerencial'" style="margin-top: 5px"/>    
                        </v-col> 
                    </v-row>
                </v-form>

            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { BeneficiarioService, ProjetoService } from '../../../core/services/projetos';

export default {
    data: () => ({
        filtro: {
            projetoId: 0,
            beneficiarioId: 0,
            dataInicio: null,
            dataTermino: null,
            modoListagem: true,
        },
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        projetoService: new ProjetoService(),
        projetos: [],
        isProjetoLoading: false,
        onSearchProjeto: null,
        beneficiarioService: new BeneficiarioService(),
        beneficiarios: [],
        isBeneficiarioLoading: false,
        onSearchBeneficiario: null,
        valid: null
    }),
    watch:{
        onSearchProjeto(val){
            if(this.isProjetoLoading) return;
            if(!val) return;
            if(this.filtro.projetoId) return;

            this.isProjetoLoading = true;
            this.projetoService.AutoComplete(val)
            .then(
                res=>{
                    this.projetos = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isProjetoLoading = false))
        },
        onSearchBeneficiario(val){
            if(this.isBeneficiarioLoading) return;
            if(!val) return;

            this.isBeneficiarioLoading = true;
            this.beneficiarioService.AutoComplete(val)
            .then(
                res=>{
                    this.beneficiarios = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isBeneficiarioLoading = false))
        }
    },
    methods: {
        GerarRelatorio(){
            if( this.$refs.form.validate()){
                this.AbrirJanela('relatorioFrequencia');
            }
        },
        LimparFiltros(){
            this.filtro = {
                projetoId: 0,
                beneficiarioId: 0,
                dataInicio: null,
                dataTermino: null,
                modoListagem: true,
            }
            this.projetos = [],
            this.beneficiarios = []
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    projetoId: this.filtro.projetoId,
                    beneficiarioId: this.filtro.beneficiarioId,
                    dataInicio: this.filtro.dataInicio,
                    dataTermino: this.filtro.dataTermino,
                    modoListagem: this.filtro.modoListagem,
                } 
            });
            window.open(routeLink.href,'_blank');
        }, 
    },
    mounted(){

    }
}

</script>